import React, { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { theme } from "../../Assets/Theme/theme";
import UploadIcon from "../../Assets/Images/Upload icon.svg";

const UploadImagesComponent = ({ onChange, initialImages = [] }) => {
  const [images, setImages] = useState(initialImages);

  const handleUploadImage = async (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      const base64Images = await Promise.all(
        [...files].map((file) => convertToBase64(file))
      );
      const updatedImages = [...images, ...base64Images];
      setImages(updatedImages);
      onChange(updatedImages);
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleRemoveImage = (indexToRemove) => {
    const updatedImages = images.filter((_, index) => index !== indexToRemove);
    setImages(updatedImages);
    onChange(updatedImages); 
  };

  return (
    <Box
      sx={{
        border: `1px solid #ccc`,
        padding: "16px 16px 0",
        borderRadius: "8px",
        width: "100%",
      }}
    >
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
        {images.map((image, index) => (
          <Box
            key={index}
            sx={{
              position: "relative",
              border: "1px solid #ccc",
              borderRadius: "8px",
              overflow: "hidden",
              width: { xs: "45%", md: "250px" },
              height: { xs: "150px", md: "250px" },
            }}
          >
            {/* Close Icon Button */}
            <IconButton
              onClick={() => handleRemoveImage(index)}
              sx={{
                position: "absolute",
                top: "4px",
                right: "4px",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                color: "white",
                zIndex: 2,
                "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
              }}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>

            {/* Uploaded Image */}
            <img
              src={image}
              alt={`Uploaded ${index + 1}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        ))}

        {/* Upload Box */}
        <Box
          sx={{
            border: `2px solid ${theme.colors.orange}`,
            borderRadius: "8px",
            width: { xs: "45%", md: "250px" },
            height: { xs: "150px", md: "250px" },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            cursor: "pointer",
          }}
        >
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={handleUploadImage}
            style={{
              opacity: 0,
              position: "absolute",
              width: "100%",
              height: "100%",
              cursor: "pointer",
            }}
          />
          <Box
            sx={{
              textAlign: "center",
              pointerEvents: "none",
            }}
          >
            <img src={UploadIcon} />
            <Typography variant="body2" sx={{ color: "#121212" }}>
              Upload Your Image
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Image Count */}
      <Typography
        variant="body2"
        sx={{ textAlign: "right", mb: "2px", color: "#121212" }}
      >
        Images Attached: {images.length}
      </Typography>
    </Box>
  );
};

export default UploadImagesComponent;
